import { useTranslation } from "react-i18next";
import ActionButton from "../../components/ActionButton/ActionButton";
import "./ServiceDetailsWebProgramming.css";
import ContactForm from "../../components/ContactForm/ContactForm";
import { useState } from "react";
import Modal from "../../components/Modal/Modal";

export default function ServiceDetailsWebProgramming() {
  const { t, i18n } = useTranslation();
  /**----------------------------------------------------------------------------- */
  /**STATE VARIABLES HERE                                                          */
  /**----------------------------------------------------------------------------- */
  const [showContactForm, setShowContactForm] = useState<boolean>(false);

  /**----------------------------------------------------------------------------- */
  /**HANDLERS HERE                                                                 */
  /**----------------------------------------------------------------------------- */
  const handleCloseContactFormModalClose = () => {
    setShowContactForm(false);
  };

  const handleContactUsClick = () => {
    setShowContactForm(true);
  };
  return (
    <div className="ServiceDetailsWebProgramming--main_container">
      <div className="ServiceDetailsWebProgramming--title_description_container">
        <div className="section_title">
          {t("ServiceDetailsWebProgramming-Title")}
        </div>
        <div className="section_paragraph">
          {t("ServiceDetailsWebProgramming-Description")
            .split("\n")
            .map((paragraph: any) => (
              <p>{paragraph}</p>
            ))}
        </div>
        <div className="section_sub_title">
          {t("ServiceDetailsWebProgramming-Concept-Stage")}
        </div>
        <div className="section_paragraph">
          {t("ServiceDetailsWebProgramming-Concept-Stage-Description")
            .split("\n")
            .map((paragraph: any) => (
              <p>{paragraph}</p>
            ))}
          <ul>
            {t("ServiceDetailsWebProgramming-Concept-Stage-Pros")
              .split("\n")
              .map((element: any) => (
                <li>{element}</li>
              ))}
          </ul>
          <p>{t("ServiceDetailsWebProgramming-Concept-Summary")}</p>
          <div className="ServiceDetailsWebProgramming--action_button_container">
            <ActionButton
              backgroundColor="#0E4DE3"
              buttonText={t("ServiceDetailsWebProgramming-Contact-Button")}
              textColor={"#FFFFFF"}
              onClick={handleContactUsClick}
            />
          </div>
        </div>

        <div className="section_sub_title">
          <p>{t("ServiceDetailsWebProgramming-Implementation-Stage")}</p>
        </div>
        <div className="section_paragraph">
          {t("ServiceDetailsWebProgramming-Implementation-Stage-Description")
            .split("\n")
            .map((paragraph: any) => (
              <p>{paragraph}</p>
            ))}
          <ul>
            {t("ServiceDetailsWebProgramming-Implementation-Stage-Pros")
              .split("\n")
              .map((element: any) => (
                <li>{element}</li>
              ))}
          </ul>
          <p>{t("ServiceDetailsWebProgramming-Implementation-Summary")}</p>
          <div className="ServiceDetailsWebProgramming--action_button_container">
            <ActionButton
              backgroundColor="#0E4DE3"
              buttonText={t("ServiceDetailsWebProgramming-Contact-Button")}
              textColor={"#FFFFFF"}
              onClick={handleContactUsClick}
            />
          </div>
        </div>
      </div>
      <div className="ServiceDetailsWebProgramming--logo_container">
        <img
          className="ServiceDetailsWebProgramming--logo"
          src="web develop.jpg"
          alt=""
        />
      </div>

      {/**CONTACT FORM MODAL */}
      <div className="ServicesDetailWeb--contact_form_modal_container">
        <Modal
          children={<ContactForm subject="Programación Web"/>}
          isOpen={showContactForm}
          onClose={handleCloseContactFormModalClose}
        />
      </div>
    </div>
  );
}
